const FormField = ({ label, required, children, sublabel }) => (
  <div className="d-flex flex-column">
    <div className="d-flex gap-2">
      <p className="m-0 fw-medium small">{label}</p>{" "}
      {required && <b className="text-danger">*</b>}
    </div>
    {children}
    <i className="m-0" style={{ fontSize: "0.75rem" }}>
      {sublabel}
    </i>
  </div>
);

export default FormField;
